var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightClaimDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6035 0.648438L5.8965 1.35544L10.0428 5.50194H0V6.50194H10.0428L5.8965 10.6484L6.6035 11.3554L11.9572 6.00194L6.6035 0.648438Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightClaimDetail);
export default __webpack_public_path__ + "static/media/arrow_right_claim_detail.9853936b050ad6c50d9f7f1edceb485e.svg";
export { ForwardRef as ReactComponent };